"use client";

import { usePaidAdChannel } from "@/hooks/use-paid-ad-channel";
import { Analytics as VercelAnalytics } from "@vercel/analytics/next";
import { FacebookPixelProvider } from "./FacebookPixel";

export default function Analytics() {
  const paidAdChannel = usePaidAdChannel();

  return (
    <>
      {/* Facebook Pixel loads only for visitors who arrived from a Meta paid ad. */}
      {paidAdChannel === "meta" && <FacebookPixelProvider enabled={true} />}
      <VercelAnalytics />
      {/* Add <PosthogProvider enabled={posthog} /> here in the future */}
    </>
  );
}
